/**
 * Declarative config of the claim « Intervenants » tab
 * (`extranet.claimStakeholdersCard`, fiche 22740): stable columns `nature`
 * (CD_CATEG), `nomPrenom` (NOM_PRENOM_PER), `email` (EMAIL_PER),
 * `telephone` (TELPRINC_PER), rows in API order. Below 768px the DataList
 * mobile cards show the same values, one block per stakeholder, in the same
 * order.
 */

import type { ColumnConfig, DataListConfig } from '@components/integrated/data-list';

import type { ClaimStakeholderRow } from '../../api/claimsService';
import { EMPTY_STATE_TEXT } from '../shared/cardText';

/** Stable column keys of the stakeholders table. */
export type ClaimStakeholdersColumnKey = 'nature' | 'nomPrenom' | 'email' | 'telephone';

/** Base columns (fiche order). */
export const CLAIM_STAKEHOLDERS_COLUMNS: Readonly<
  Record<ClaimStakeholdersColumnKey, ColumnConfig>
> = {
  nature: { label: 'Nature', order: 1, type: 'text', className: 'font-medium', sortable: true },
  nomPrenom: { label: 'Nom · Prénom', order: 2, type: 'text', sortable: true },
  email: { label: 'E-mail', order: 3, type: 'text', sortable: true },
  telephone: { label: 'Téléphone', order: 4, type: 'text', sortable: true },
};

/** Base DataList config: inline rows in API order, one page, no toolbar. */
export function buildClaimStakeholdersConfig(
  componentId: string,
  rows: readonly ClaimStakeholderRow[],
): DataListConfig {
  return {
    id: componentId,
    dataSource: { data: rows as unknown as Record<string, unknown>[] },
    columns: { ...CLAIM_STAKEHOLDERS_COLUMNS },
    display: { size: 'compact', hoverable: false },
    sorting: { enabled: true },
    toolbar: { visible: false },
    pagination: { mode: 'scroll', pageSize: 999_999 },
    i18n: { emptyMessage: EMPTY_STATE_TEXT },
  };
}
